import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HeaderBread from "../../../components/HeaderBread";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import { message } from "antd";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import { constants } from "../../../constants/constants";
import DeletePop from "../../../constants/ErrorPermissionModal";
import {
  deleteAncillary,
  getAncillary,
  updateAncillaryPosition, // 👈 create this if not exists
} from "../../../utils/ApiCalls/Ancillary";
import { checkPermission } from "../../../utils/Validation/checkPermission";
import CustomizedDragNDrop from "../../../components/UI/CustomizedDragNDrop";

const Ancillary = () => {
  const navigate = useNavigate();
  const navigation = [
    { title: "Home", route: "/" },
    { title: "Ancillary", route: "/website/masters/ancillary-details" },
  ];
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [{ permission }, dispatch] = useDataLayerValue();

  
  
    const locationP = useLocation();
  
    const [page, setPage] = useState(
      () => parseInt(new URLSearchParams(locationP.search).get("page")) || 1
    );
    const [pageSize, setPageSize] = useState(
      () => parseInt(new URLSearchParams(locationP.search).get("pageSize")) || 10
    );
    const [search, setSearch] = useState(
      () => new URLSearchParams(locationP.search).get("search") || ""
    );
  
    useEffect(() => {
      const params = new URLSearchParams(locationP.search);
      const pageParam = parseInt(params.get("page")) || 1;
      const pageSizeParam = parseInt(params.get("pageSize")) || 10;
      const searchParam = params.get("search") || "";
  
      // setPage(pageParam);
      // setPageSize(pageSizeParam);
      setSearch(searchParam);
    }, [locationP.search]);
  
    useEffect(() => {
      const params = new URLSearchParams();
      const currentParams = new URLSearchParams(locationP.search);
  
      params.set("page", page);
      params.set("pageSize", pageSize);
      if (search) params.set("search", search);
  
      if (currentParams.toString() !== params.toString()) {
        navigate({ search: params.toString() }, { replace: true });
      }
    }, [page, pageSize, search, navigate, locationP.search]);
  


  const columns = [
    {
      title: "Sl",
      width: 30,
      dataIndex: "id",
      key: "id",
      fixed: "left",
      render: (position, record, index) => (page - 1) * pageSize + index + 1,
    },
    {
      title: "Image",
      width: 100,
      dataIndex: "image",
      key: "image",
      render: (image) => (
        <img
          alt="anc"
          src={`${constants.MEDIAURL}/${image}`}
          style={{ width: "100px", height: "80px" }}
        />
      ),
    },
    {
      title: "Title",
      dataIndex: "english_title",
      key: "english_title",
      width: 50,
    },
    {
      title: "Code",
      dataIndex: "ancillary_code",
      key: "ancillary_code",
      width: 50,
    },
    {
      title: "Action",
      key: "operation",
      width: 100,
      render: (text, record) => (
        <div className="table_action_btn">
          <button className="btn" onClick={() => handleEdit(record.id)}>
            <i className="ri-edit-2-line" title="Edit"></i>
          </button>
          <DeletePop onConfirm={() => handleDelete(record.id)}>
            <div className="btn delete_btn">
              <i className="ri-delete-bin-line" title="Delete"></i>
            </div>
          </DeletePop>
        </div>
      ),
    },
  ];

  useEffect(() => {
    getData(page);
  }, [page, pageSize]);

  const getData = async (value) => {
    let data = await getAncillary({ page: value, limit: pageSize });
    if (data.error) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    } else if (data.data) {
      setRows(data.data);
      setCount(data.count);
    }
  };

  const handleEdit = (id) => {
    if (checkPermission(permission, "update_per", "NewsLetter", window.location.pathname)) {
      navigate("/website/masters/ancillary-details/edit/" + id);
    } else {
      message.error("Update permission missing");
    }
  };

  const handleDelete = async (id) => {
    if (checkPermission(permission, "delete_per", "NewsLetter", window.location.pathname)) {
      await deleteAncillary(id);
      getData(page);
    } else {
      message.error("Missing Permission for delete");
    }
  };

  const updatePositionHandler = async (updatedRows) => {
    if (!checkPermission(permission, "update_per", "Ancillary", window.location.pathname)) {
      message.error("Update permission missing");
      return;
    }

    try {
      const response = await updateAncillaryPosition(updatedRows);
      if (response.error) {
        message.error(response.error);
      } else {
        message.success("Positions updated successfully");
        getData(page);
      }
    } catch (err) {
      message.error("Failed to update position");
    }
  };


  return (<Layout type={"read_per"} module_data={"Ancillary"}> <CustomHeaderTitle title={"Ancillary"} /> <div> <HeaderBread navigation={navigation} title={"Ancillary"} /> <section className="content" style={{ marginTop: "20px" }}> <div className="container-fluid"> <div className="card"> <div className="card-header two_item"> <h5 className="card-title">Ancillary List</h5> <div className="two_item"> <Link to="/website/masters/ancillary-details/add" className="btn add_v_btn mx-2" > Add Ancillary </Link> </div> </div> <div className="card-body"> <div className="table_holder"> {rows?.length > 0 && (<CustomizedDragNDrop setRows={setRows} setPageSize={setPageSize} setPage={setPage} pageSize={pageSize} page={page} count={count} columns={columns} rows={rows} title={"Ancillary"} updatePosition={updatePositionHandler} />)} </div> </div> </div> </div> </section> </div> </Layout>);
}; export default Ancillary;
